const Slider = {
	config: {
		'slider': 'Slider',
		'navEl':'.slider-remote',
		'loop': false,
		'autoWidth': false,
		'nav': true,
		'dots': true,
		'progress': false,
		'counter': false,
		'margin': 24,
		'stagePadding': 0,
		'items': 1,
		'navText': ['', ''],
	},

	init() {
		const sliders = $('[component="Slider"]');
		if (!sliders.length) return;
		// console.log(this.config.slider, sliders)

		sliders.each((i, el) => {
			this.prepare($(el), this.config);
		});
	},

	prepare(el, config) {

		if (!config.nav) {
			this.bind(el, config);
			return;
		}

		const nav = el.find(config.navEl);

		config.navContainer = $('<div class="arrows"></div>');
		config.navContainer.appendTo(nav);

		const holder = $('<div class="holder"></div>');
		if (config.progress || config.dots) {
			holder.appendTo(nav);
		}

		if (config.progress) {
			config.progressEl = $('<div class="progress"><div class="inner"></div></div>');
			config.progressEl.appendTo(holder);
		}

		if (config.dots) {
			config.dotsContainer = $('<div class="dots"></div>');
			config.dotsContainer.appendTo(holder);
		}

		if (config.counter) {
			config.counterEl = $('<div class="counter"></div>');
			config.counterEl.appendTo(nav);
		}

		config.responsive = el.data('responsive') || {};

		this.bind(el, config);
	},

	bind(el, config) {
		const slider = el.find('[block="slider"]');

		slider.addClass('owl-carousel');

		slider.on('initialized.owl.carousel', (evt) => {
			setTimeout(() => {
				this.organizeNav(el, config);
			},10)

		});

		// el.on('changed.owl.carousel', (evt) => {
		// 	this.updateSlide(evt);
		// });

		slider.owlCarousel(config);
	},

	organizeNav(el, config) {
		el.find(config.navEl).find('.holder').insertAfter(el.find(config.navEl).find('.owl-prev'));
	},

	updateSlide(evt) {
		const stage = $(evt.currentTarget);
		const slider = $(evt.currentTarget).parent('[component="Slider"]');
		const extendClass = slider.attr('extend-class');
		const nav = stage.next('nav');
		const slide = this.getCurrentSlide(evt.relatedTarget);

		this.updateProgress(evt, nav);
		this.updateNav(evt, nav);
		this.updateCounter(evt, nav, slider);

		if (window[extendClass] instanceof Object) {
			if (window[extendClass].setSlide instanceof Function)
				window[extendClass].setSlide(slider, slide);
		}
	},

	getCurrentSlide(slider) {
		const isLooped = slider.options.loop;
		const count = slider._items.length - 1;
		let index = isLooped ? slider.current() - 2 : slider.current();
		if (index < 0) index = count;
		return $(slider._items[index]).children();
	},

	updateNav(evt, nav) {
		if (!nav.length) return;
		const navTheme = this.getCurrentSlide(evt.relatedTarget).attr('nav-theme');

		// if (!navTheme) return;
		nav.attr('theme', navTheme);
	},

	updateCounter(evt, nav, slider) {
		slider.attr('slide', evt.item.index);
		const counter = nav.find('.counter');
		if (!counter.length) return;

		const pageItems = evt.page.size - 1;
		const page = pageItems + evt.item.index + 1;
		const total = evt.item.count;

		counter.html(
			'<span class="page">' + page + '</span>' +
			'<span class="separator">/</span>' +
			'<span class="total">' + total + '</span>' +
			'');
	},

	updateProgress(evt, nav) {
		const progress = nav.find('.progress');
		if (!progress.length) return;

		const pageItems = evt.page.size - 1;
		const percent = Math.round(((pageItems + evt.item.index + 1) / evt.item.count) * 100);

		progress.children('.inner').css({
			width: `${percent}%`,
		});
	},

	resize() {
	},

	kill(el) {
		el.owlCarousel('destroy').removeClass('owl-carousel');
	},
};

export default Slider;

